// 网格分享逻辑（Product / Funding / Channel 三 grid 共用）
//
// 三 grid 此前各自复制了 showModal / isGenerating / currentCardIndex 三个状态 +
// openShareModal / closeModal / onShareSubmit 三个方法，仅「分享图宽度、GA 事件后缀、
// 文件名格式」不同。这里统一为 mixin，差异通过 data 配置参数化：
//   - shareCardRef：卡片根元素的 ref 名（默认 'productCard'，Channel 用 'channelCard'）
//   - shareCardWidth：分享图宽度（默认 420）
//   - shareGtagType：GA 事件后缀 product / funding / channel
//   - buildShareDownloadName(name)：文件名构造（默认 "品牌-名称.png"，Product 叠加日期）
//
// 模板中仍由各 grid 保留一行 <ShareModal :visible :is-generating @submit @close />；
// 「显示更多」按钮走 gridPaginationMixin（hasMoreItems / loadMore），本 mixin 不涉及。

import { generateShareCard } from '../utils/shareCard';

export default {
  data() {
    return {
      showModal: false,
      isGenerating: false, // 生成卡片 loading 态
      currentCardIndex: null,
      // —— 以下为子类按需覆盖的配置 ——
      shareCardRef: 'productCard', // 卡片根元素 ref 名
      shareCardWidth: 420, // 分享图宽度
      shareGtagType: 'product', // GA 事件后缀
    };
  },
  methods: {
    openShareModal(index) {
      this.currentCardIndex = index;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    // 文件名构造：默认 "品牌-名称.png"；Product 叠加日期后缀，覆盖此方法即可
    buildShareDownloadName(name) {
      return `${this.$t('interface.ai_inspiration_hub')}-${name}.png`;
    },
    // 取当前被分享的条目 —— 必须与「实际渲染列表」同源。
    //
    // 卡片 DOM（this.$refs[shareCardRef][index]）始终由 displayedItems 渲染（见 gridPaginationMixin），
    // 而 displayedItems 在 ProductGrid 的「日筛选」下是整周 products 的子集
    // （ProductGrid 的 displayedProducts watch 会把它重置为 filtered.slice(0, itemsPerPage)）。
    // 两者索引空间不一致：旧实现取 this[sourceKey][index]（整周列表），
    // 于是「日筛选 + 卡片在子集里的下标」会解析到另一个产品 ——
    // 导出图内容是对的（DOM 来自 displayedItems），文件名与 GA event_label 却是别人的。
    // 例：2026-09-14~09-20 周，09-18 日筛选下 Second Eyes 位于子集下标 35，
    // 而整周 products[35] = MCPJam ⇒ 下载文件名变成「AI灵感库-MCPJam-2026-09-14-2026-09-20.png」。
    resolveSharedItem(index) {
      if (!Number.isInteger(index) || index < 0) return null;
      const rendered = this.displayedItems;
      // 无 displayedItems（未接 gridPaginationMixin 的宿主）时回退到数据源，保持兼容
      const list = Array.isArray(rendered) && rendered.length ? rendered : this[this.sourceKey];
      return (list && list[index]) || null;
    },
    // 分享弹窗提交：生成并下载卡片图片
    onShareSubmit({ sharer, message }) {
      this.isGenerating = true;
      const index = this.currentCardIndex;
      const item = this.resolveSharedItem(index);
      if (!item) {
        this.isGenerating = false;
        return;
      }
      const hasMsg = message && message.trim() !== '';
      // Promise.resolve().then 包裹：确保同步异常也能复位 isGenerating；
      // 截图失败的错误已在 generateShareCard 内部 console.error，这里静默吞掉。
      Promise.resolve()
        .then(() => generateShareCard(this.$refs[this.shareCardRef][index], {
          itemName: item.name,
          brandText: this.$t('interface.ai_inspiration_hub'),
          width: this.shareCardWidth,
          downloadName: this.buildShareDownloadName(item.name),
          gtagDownload: `download_${this.shareGtagType}`,
          gtagShareDownload: `share_download_${this.shareGtagType}`,
          shareData: hasMsg ? { sharer, message } : null,
        }))
        .catch(() => {})
        .finally(() => { this.isGenerating = false; });
    },
  },
};
